import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: '20px',
  padding: '28px 34px',
  width: '100%',
  maxWidth: '450px',

  '& .MuiGrid2-root': {
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
  '& .MuiFormControlLabel-root': {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  '& .MuiCheckbox-root': {
    padding: '0 9px',
  },
}));
